import { defineComponent as _defineComponent } from 'vue';
import { ACHIEVEMENT_DUPLICATE_MODE, ACHIEVEMENT_VISIBILITY_TYPE } from '@/consts';
import { computed } from 'vue';
import Markdown from '@/components/Markdown/Markdown.vue';
import { url } from '@/helper/urls';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AchievementInfo',
    props: {
        achievement: { type: Object, required: true },
        scopeName: { type: String, default: '' },
    },
    setup(__props) {
        const props = __props;
        const isMultiple = computed(() => props.achievement.duplicateMode === ACHIEVEMENT_DUPLICATE_MODE.MULTIPLE);
        const visibilityTypeName = computed(() => {
            const value = Object.entries(ACHIEVEMENT_VISIBILITY_TYPE)
                .find(([_key, value]) => value === props.achievement.visibilityType)[0].toLowerCase();
            return value;
        });
        return { __sfc: true, props, isMultiple, visibilityTypeName, Markdown, url };
    }
});
